import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take, tap, map } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { SupplierHttpService } from
  '@feature/_app_modules/mojo-for-suppliers/mfs-shared/suppliers/services/supplier-http.service';
import { CreditorHttpService } from
  '@feature/_app_modules/mojo-for-suppliers/mfs-shared/creditors/services/creditor-http.service';
import { UserAdminService } from '@feature/_app_modules/mojo-for-suppliers/user-admin/services/user-admin.service';
import { PreviewModeService } from '@feature/preview-mode/services/preview-mode.service';
import { MfsPreviewDialogResult } from '@feature/preview-mode/mfs-preview-mode/models/mfs-preview-dialog-result';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { Router } from '@angular/router';
import * as userSettingsActions from '@user-settings/actions/user-settings';
import { WellKnownRoutePaths } from '@routing/well-known-route-paths';
import { MfsProductService } from '@product/services/mfs-product.service';
import {OverviewService} from "@feature/overview";

@Component({
  selector: 'mojo-mfs-preview-mode-dialog-container',
  templateUrl: './mfs-preview-mode-dialog-container.component.html'
})
export class MfsPreviewModeDialogContainerComponent implements OnInit {

  users: Observable<SelectItem[]>;
  suppliers: Observable<SelectItem[]>;
  creditors: Observable<SelectItem[]>;

  showDialog: boolean;

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly router: Router,
    private readonly previewModeService: PreviewModeService,
    private readonly userAdminService: UserAdminService,
    private readonly creditorHttpService: CreditorHttpService,
    private readonly supplierService: SupplierHttpService,
    private readonly overviewService: OverviewService) {
  }

  ngOnInit() {
  }

  onCancel() {
    this.showDialog = false;
  }

  onOk(dialogResult: MfsPreviewDialogResult) {
    this.previewModeService.enterMfsPreviewMode(dialogResult.supplier, dialogResult.creditor, dialogResult.user)
      .pipe(take(1)).subscribe(result => {
        this.store.dispatch(new userSettingsActions.Load());
        this.overviewService.loadOverviewConfiguration();
        this.router.navigated = false;
        this.router.navigate([WellKnownRoutePaths.fromRoot(MfsProductService.homeDashboard)]);
      });
    this.showDialog = false;
  }

  private getUserList(): Observable<SelectItem[]> {
    return this.userAdminService.getUsers().pipe(map(users => {
      return users.map(user => {
        const item: SelectItem = {
          label: user.email,
          value: user.mfsUserId
        };
        return item;
      });
    }));
  }

  private getCreditorList(): Observable<SelectItem[]> {
    return this.creditorHttpService.getOtherCreditors().pipe(map(creditors => {
      return creditors.map(creditor => {
        const item: SelectItem = {
          label: `${creditor.AccountNo} - ${creditor.AccountName}`,
          value: creditor.Uri as any
        };
        return item;
      });
    }));

  }

  private getSupplierList(): Observable<SelectItem[]> {
    return this.supplierService.getAllSuppliers().pipe(map(suppliers => {
      return suppliers.map(supplier => {
        const item: SelectItem = {
          label: `${supplier.Ref} - ${supplier.Name}`,
          value: supplier.Ref as any
        };
        return item;
      });
    }));
  }


  doShowDialog() {
    this.userAdminService.loadAllUsers();
    this.users = this.getUserList();
    this.suppliers = this.getSupplierList();
    this.creditors = this.getCreditorList();
    this.showDialog = true;
  }

}
